import React, { useEffect, useState } from "react";
import { Routes, Route, useParams, NavLink } from "react-router-dom";

import Loader from "../../../components/loader";

import api from "../../../services/api";

import Info from "./info";
import Raw from "./raw";
import EmailEvents from "./email_events";
import { HiArrowLeft } from "react-icons/hi2";
import { HiExternalLink } from "react-icons/hi";

const STATUS_COLORS = {
  "Timetable sent": "bg-blue-100 text-blue-800",
  "Signed timetable": "bg-green-100 text-green-800",
  "Payment in progress": "bg-yellow-100 text-yellow-800",
  "Late payment": "bg-red-100 text-red-800",
  "Late payment in progress": "bg-orange-100 text-orange-800",
  "In recovery": "bg-purple-100 text-purple-800",
};

export default function View() {
  const [cashout, setCashout] = useState(null);
  const [project, setProject] = useState(null);

  const { id } = useParams();

  async function get() {
    try {
      const { data } = await api.get(`/cashout/${id}`);
      setCashout(data);
    } catch (e) {
      console.log("a", e);
    }
  }
  async function getProject() {
    try {
      const { data } = await api.get(`/project/${cashout.projectId}`);
      setProject(data);
    } catch (e) {
      console.log("a", e);
    }
  }

  useEffect(() => {
    get();
  }, [id]);

  useEffect(() => {
    if (!cashout) return;
    getProject();
  }, [cashout]);

  if (!cashout || !project) return <Loader />;

  return (
    <div>
      <div className="m-2">
        <div className="flex items-center gap-2">
          <NavLink to="/cashout" className="hover:bg-gray-50 p-2 rounded-full">
            <HiArrowLeft className="h-4 w-4" />
          </NavLink>
          <div className="text-lg font-bold">{cashout.projectName}</div>
          <div className={`px-2 py-1 rounded text-xs ${STATUS_COLORS[cashout.status]}`}>{cashout.status}</div>
          <NavLink to={`/project/${cashout.projectId}`} className="hover:bg-gray-50 p-2 rounded-full text-sm flex items-center gap-1 hover:underline">
            view project
            <HiExternalLink className="h-4 w-4" />
          </NavLink>
        </div>
        <div className="mb-2 flex items-center justify-between gap-2 mt-2">
          <nav className="flex-1 bg-white rounded-md flex item-center gap-1 border border-neutral-300 p-1 overflow-x-auto">
            <TabItem href={"/"} title={"Info"} />
            <TabItem href={"/email"} title={"Email"} />
            <TabItem href={"/raw"} title={"Raw"} />
          </nav>
        </div>
        <Routes>
          <Route exact path="/" index element={<Info cashout={cashout} setCashout={setCashout} />} />
          <Route path="/email" element={<EmailEvents project={project} />} />
          <Route path="/raw" element={<Raw cashout={cashout} />} />
        </Routes>
      </div>
    </div>
  );
};

const TabItem = ({ href, title }) => {
  const { id } = useParams();
  return (
    <NavLink to={`/cashout/${id}${href}`} className={({ isActive }) => (isActive ? "blue-btn" : "transparent-btn cursor-pointer relative rounded flex items-center")}>
      <div className="flex items-center gap-2 truncate">{title}</div>
    </NavLink>
  );
};
